import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  projects: [],
};

const getters = {
  getProjects: (state) => state.projects,
  getProjectById: (state) => (id) => {
    return state.projects.find((item) => item.id == id);
  },
  // Getter to return projects with cover image instead of images array
  getProjectsWithCoverImage: (state) => {
    return state.projects.map((project) => {
      // Find the cover image
      const coverImage = project.images.find((image) => image.isCover);

      // Return a new project object
      return {
        ...project,
        // Replace images array with the cover image or null if not found
        coverImage: coverImage || null,
        // Optionally, remove the images array if not needed
        // ...other properties
      };
    });
  },
};

const actions = {
  async fetchProjects({ commit }) {
    try {
      const resp = await api.get("/projects");
      if (resp.status == 200) {
        const projects = resp.data.data;
        console.log("projects", projects);
        commit("setProjects", projects);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async fetchOneProject({ commit }, id) {
    try {
      const resp = await api.get(`/projects/${id}`);
      if (resp.status == 200) {
        const project = resp.data.data;
        console.log("project", project);
        commit("setProjects", project);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async updateProject({ commit }, project) {
    try {
      const id = project.id;
      project._method = "patch";
      const resp = await api.post(`/projects/${id}`, project);
      if (resp.status == 200) {
        const project = resp.data.data;

        commit("updateProject", project);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async addProject({ commit }, project) {
    try {
      const resp = await api.post(`/projects`, project);

      console.log("resp", resp.data);
      if (resp.status == 201) {
        const project = resp.data.data;

        commit("addProject", project);
      }
      console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      // console.log("error", error);
      // console.log("error", error.response.status);
      // console.log("error", error.response.data);
      // console.log("hhhh", responseHandler.respH1(error.response));
      return responseHandler.respH1(error.response);
      //return false;
    }
  },
  async deleteProject({ commit }, id) {
    try {
      const resp = await api.delete(`/projects/${id}`);

      console.log("resp", resp.data);
      console.log("resp delete: ", resp.status);
      if (resp.status == 203) {
        commit("deleteProject", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteProjectImage({ commit }, data) {
    console.log("data to delete:", data);
    const id = data.image_id;
    // const project_id = data.image_id;
    try {
      const resp = await api.delete(`/project-images/${id}`);

      console.log("resp", resp.data);
      if (resp.status == 203) {
        commit("deleteProjectImage", data);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },

  async addProjectImage({ commit }, image) {
    console.log("image", image);
    try {
      const formData = new FormData();
      formData.append("image", image.image);

      formData.append("alt", image.alt);
      formData.append("isCover", image.isCover ? "1" : "0");
      formData.append("project_id", image.project_id);
      const resp = await api.post(`/project-images`, formData);

      if (resp.status == 201) {
        const image = resp.data.data;
        commit("addProjectImage", image);
      }
      console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },

  async updateProjectImage({ commit }, image) {
    console.log("image", image);
    try {
      const formData = new FormData();
      formData.append("image", image.image);

      formData.append("alt", image.alt);
      formData.append("isCover", image.isCover ? "1" : "0");
      formData.append("project_id", image.project_id);
      formData.append("_method", "patch");
      const resp = await api.post(`/project-images/${image.id}`, formData);

      if (resp.status == 201) {
        const image = resp.data.data;
        commit("updateProjectImage", image);
      }
      console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  addProjectImage(state, image) {
    const index = state.projects.findIndex((p) => p.id == image.project_id);
    if (index != -1) {
      state.projects[index].images.unshift(image);
    }
  },
  updateProjectImage(state, image) {
    const index_project = state.projects.findIndex(
      (p) => p.id == image.project_id
    );
    if (index_project != -1) {
      const index_image = state.projects[index_project].images.findIndex(
        (p) => p.id == image.id
      );
      if (index_image !== -1) {
        state.projects[index_project].images[index_image] = image;
      }
    }
  },
  setProjects(state, projects) {
    state.projects = projects;
  },
  updateProject(state, project) {
    const id = project.id;
    const index = state.projects.findIndex((project) => project.id == id);
    if (index !== -1) {
      state.projects[index] = project;
    }
  },
  addProject(state, project) {
    state.projects.unshift(project);
  },

  deleteProject(state, id) {
    console.log("to delete: ", id);
    const index = state.projects.findIndex((p) => p.id == id);
    console.log("to delete::::", state.projects[index]);
    if (index !== -1) {
      state.projects.splice(index, 1);
    }
  },
  deleteProjectImage(state, data) {
    const index_project = state.projects.findIndex(
      (p) => p.id == data.project_id
    );
    if (index_project != -1) {
      const index_image = state.projects[index_project].images.findIndex(
        (p) => p.id == data.image_id
      );
      if (index_image !== -1) {
        state.projects[index_project].images.splice(index_image, 1);
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
